import { useLanguage } from './useLanguage';

export const useTurkish = () => {
  const language = useLanguage();

  return language.language === 'tr' || language.browserLanguage === 'tr';
};
